module.exports = __webpack_public_path__ + "img/cards-active.62bd1e04.png";